import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
   
//import { Invoice } from '../../interfaces/invoice.interface'; 
import { CustomerCode } from '../../interfaces/customercode.interface';
import { Product } from '../../interfaces/product.interface';
import { Employee } from '../../interfaces/employee.interface';
import { WarehouseCode } from '../../interfaces/warehousecode.interface';
import { InvoiceService } from "../../services/invoice";
import { WarehousecodeService } from "../../services/warehousecode";
import { CustomerCodeService } from "../../services/customercode";
import { ProductcodeService } from "../../services/productcode";
import { EmployeeService } from '../../services/employee';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-invoice',
  imports: [ReactiveFormsModule],
  templateUrl: './add-invoice.html',
  styleUrl: './add-invoice.css'
})
export class AddInvoiceComponent implements OnInit {

  myForm: FormGroup;
  customercodes: CustomerCode[] = [];
  //products: Product[] = [];
  employeecodes: Employee[] = [];
  warehousecodes: WarehouseCode[] = [];
  productcodes: Product[] = [];

  constructor(private invoiceService: InvoiceService, 
              private warehousecodeService: WarehousecodeService,
              private customercodeService: CustomerCodeService,
              private productcodeService: ProductcodeService,
              private employeeService: EmployeeService,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                  customercode: new FormControl('',[Validators.required,Validators.maxLength(30)]),
                  productcode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  employeecode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  shiptoaddressserial: new FormControl('',[Validators.pattern('^[0-9]*$')]),
                  invoiceno: new FormControl('',[Validators.required,Validators.maxLength(30)]),
                  invoicedate: new FormControl('',[Validators.required,Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  warehousecode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  schemecode: new FormControl('',[Validators.maxLength(25)]),
                  volumesold: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  volumeid: new FormControl('',[Validators.required,Validators.maxLength(1)]),
                  grossturnover: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  cogs: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  producttype: new FormControl('',[Validators.maxLength(1)]),
                  lineno: new FormControl('',[Validators.min(0),Validators.maxLength(8),Validators.pattern('[0-9]+')]),
                  customerpo: new FormControl('',[Validators.maxLength(100)]),
                  discount: new FormControl('',[Validators.min(0)]),
                  creationdate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  modifieddate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  netturnover: new FormControl('',[Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  supplierorderno: new FormControl('',[Validators.maxLength(30)]),
                  orderdate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  deliverynoteno: new FormControl('',[Validators.maxLength(30)]),
                  deliverynotedate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  retaildealerid: new FormControl('',[Validators.maxLength(20)]),
                  refinvoicenocredit: new FormControl('',[Validators.maxLength(30)]),
                  reflinenocreditnote: new FormControl('',[Validators.pattern('[0-9]+')]),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }

async addInvoice(): Promise<void>
  {
    // id
    // distid
    // uploaded
    var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";
    var productcode = this.myForm.value.productcode != null ? this.myForm.value.productcode.trim() : "";
    var employeecode = this.myForm.value.employeecode != null ? this.myForm.value.employeecode.trim() : "";
    var shiptoaddressserial = this.myForm.value.shiptoaddressserial != null ? this.myForm.value.shiptoaddressserial : null;
    var invoiceno = this.myForm.value.invoiceno != null ? this.myForm.value.invoiceno.trim() : "";
    var invoicedate = this.myForm.value.invoicedate != null ? this.myForm.value.invoicedate.trim() : "0000-00-00";
    var warehousecode = this.myForm.value.warehousecode != null ? this.myForm.value.warehousecode.trim() : "";
    var schemecode = this.myForm.value.schemecode != null ? this.myForm.value.schemecode.trim() : "";
    var volumesold = this.myForm.value.volumesold != null ? this.myForm.value.volumesold : null;
    var volumeid = this.myForm.value.volumeid != null ? this.myForm.value.volumeid.trim() : "";
    var grossturnover = this.myForm.value.grossturnover != null ? this.myForm.value.grossturnover : 0;
    var cogs = this.myForm.value.cogs != null ? this.myForm.value.cogs : 0;
    var producttype = this.myForm.value.producttype != null ? this.myForm.value.producttype.trim() : "";
    var lineno = this.myForm.value.lineno != null ? this.myForm.value.lineno : 0;
    var customerpo = this.myForm.value.customerpo != null ? this.myForm.value.customerpo.trim() : "";
    var discount = this.myForm.value.discount != null ? this.myForm.value.discount : 0;
    var creationdate = this.myForm.value.creationdate != null ? this.myForm.value.creationdate.trim() : "";
    var modifieddate = this.myForm.value.modifieddate != null ? this.myForm.value.modifieddate.trim() : "";
    var netturnover = this.myForm.value.netturnover != null ? this.myForm.value.netturnover : 0;
    var supplierorderno = this.myForm.value.supplierorderno != null ? this.myForm.value.supplierorderno.trim() : "";
    var orderdate = this.myForm.value.orderdate != null ? this.myForm.value.orderdate.trim() : "";
    var deliverynoteno = this.myForm.value.deliverynoteno != null ? this.myForm.value.deliverynoteno.trim() : "";
    var deliverynotedate = this.myForm.value.deliverynotedate != null ? this.myForm.value.deliverynotedate.trim() : "";
    var retaildealerid = this.myForm.value.retaildealerid != null ? this.myForm.value.retaildealerid.trim() : "";
    var refinvoicenocredit = this.myForm.value.refinvoicenocredit != null ? this.myForm.value.refinvoicenocredit.trim() : "";
    var reflinenocreditnote = this.myForm.value.reflinenocreditnote != null ? this.myForm.value.reflinenocreditnote : 0;
    var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.invoiceService.create(customercode,productcode,employeecode,shiptoaddressserial,invoiceno,invoicedate,warehousecode,schemecode,volumesold,volumeid,grossturnover,cogs,producttype,lineno,customerpo,discount,creationdate,modifieddate,netturnover,supplierorderno,orderdate,deliverynoteno,deliverynotedate,retaildealerid,refinvoicenocredit,reflinenocreditnote,uploaded);
          this.cdr.detectChanges();
          this.router.navigateByUrl('invoice'); 
        } catch (error) {
          console.error('createinvoice error',error);
        }

    

  }

  get customercode() {
    return this.myForm.get('customercode');
  }

  get productcode() {
    return this.myForm.get('productcode');
  }

  get employeecode() {
    return this.myForm.get('employeecode');
  }

  get shipotoaddressserial() {
    return this.myForm.get('shipotoaddressserial');
  }
  get invoiceno() {
    return this.myForm.get('invoiceno');
  }
  get invoicedate() {
    return this.myForm.get('invoicedate');
  }
  get warehousecode() {
    return this.myForm.get('warehousecode');
  }
  get schemecode() {
    return this.myForm.get('schemecode');
  }
  get volumesold() {
    return this.myForm.get('volumesold');
  }
  get volumeid() {
    return this.myForm.get('volumeid');
  }
  get grossturnover() {
    return this.myForm.get('grossturnover');
  }
  get cogs() {
    return this.myForm.get('cogs');
  }
  get producttype() {
    return this.myForm.get('producttype');
  }
  get lineno() {
    return this.myForm.get('lineno');
  }
  get customerpo() {
    return this.myForm.get('customerpo');
  }
  get discount() {
    return this.myForm.get('discount');
  }
  get creationdate() {
    return this.myForm.get('creationdate');
  }
  get modifieddate() {
    return this.myForm.get('modifieddate');
  }
  get netturnover() {
    return this.myForm.get('netturnover');
  }
  get supplierorderno() {
    return this.myForm.get('supplierorderno');
  }
  get orderdate() {
    return this.myForm.get('orderdate');
  }
  get deliverynoteno() {
    return this.myForm.get('deliverynoteno');
  }
  get deliverynotedate() {
    return this.myForm.get('deliverynotedate');
  }
  get retaildealerid() {
    return this.myForm.get('retaildealerid');
  }
  get refinvoicenocredit() {
    return this.myForm.get('refinvoicenocredit');
  }
  get reflinenocreditnote() {
    return this.myForm.get('reflinenocreditnote');
  }
  get uploaded() {  
    return this.myForm.get('uploaded');
  }

  async ngOnInit(): Promise<void> 
  {
    try 
    {
      this.warehousecodes = await this.warehousecodeService.getWarehousecodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getwarehousecodes in invoice',error);
    }

    try 
    {
      this.customercodes = await this.customercodeService.getCustomercodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getcustomercodes in invoice',error);
    }

    try 
    {
      this.productcodes = await this.productcodeService.getProductcodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getproductcodes in invoice',error);
    }

    try 
    {
      this.employeecodes = await this.employeeService.getEmployees();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getEmployees in invoice',error);
    }

  }

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('invoice');
  }

}
